// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7463":"ba19a562","8785":"ba19a562"}[chunkId] + ".chunk.css";
};